class CustomOrderAcknowledgment extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.errorMessage = this.querySelector('[data-acknowledgment-error]');
    this.productForm = this.closest('product-form-component');
    this.form = this.productForm?.querySelector('form') || this.closest('form');

    if (!this.checkbox) return;

    this.form?.addEventListener('submit', this.handleSubmit, true);
    this.checkbox.addEventListener('invalid', this.handleInvalid);
    this.checkbox.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit, true);
    this.checkbox?.removeEventListener('invalid', this.handleInvalid);
    this.checkbox?.removeEventListener('change', this.handleChange);
  }

  handleSubmit = (event) => {
    if (!this.checkbox.checked) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError();
      return;
    }

    this.updateTimestamp();
  };

  handleInvalid = () => {
    this.showError();
  };

  handleChange = () => {
    this.checkbox.removeAttribute('aria-invalid');
    if (this.errorMessage) this.errorMessage.hidden = true;

    if (this.checkbox.checked) {
      this.updateTimestamp();
      return;
    }

    const timestamp = this.form?.querySelector('[name="properties[Custom Order Acknowledgment Date]"]');
    if (timestamp) timestamp.value = '';
  };

  showError() {
    this.checkbox.setAttribute('aria-invalid', 'true');
    if (this.errorMessage) this.errorMessage.hidden = false;
    this.checkbox.focus();
  }

  updateTimestamp() {
    if (!this.productForm || !this.form) return;

    const timestamp = this.form.querySelector('[name="properties[Custom Order Acknowledgment Date]"]');
    if (!timestamp) return;
    timestamp.value = new Date().toISOString();
  }
}

if (!customElements.get('custom-order-acknowledgment')) {
  customElements.define('custom-order-acknowledgment', CustomOrderAcknowledgment);
}

class CustomOrderCartConfirmation extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.errorMessage = this.querySelector('[data-acknowledgment-error]');
    if (!this.checkbox) return;

    this.addEventListener('click', this.handleClick, true);
    this.checkbox.addEventListener('change', this.handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick, true);
    this.checkbox?.removeEventListener('change', this.handleChange);
  }

  handleClick = (event) => {
    const checkoutControl = event.target.closest('#checkout, button[name="checkout"]');
    if (!checkoutControl || this.checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.checkbox.setAttribute('aria-invalid', 'true');
    if (this.errorMessage) this.errorMessage.hidden = false;
    this.checkbox.focus();
  };

  handleChange = () => {
    this.checkbox.removeAttribute('aria-invalid');
    if (this.errorMessage) this.errorMessage.hidden = true;
  };
}

if (!customElements.get('custom-order-cart-confirmation')) {
  customElements.define('custom-order-cart-confirmation', CustomOrderCartConfirmation);
}
